import { queryClient } from "src/lib/react-query";
import { itAdminApi } from "./ita-home";
import { queryOptions, useMutation } from "@tanstack/react-query";

function itaSteelUserQueryOptions() {
    return queryOptions({
        queryKey: [
            "ita-steel-users"
        ],
        queryFn: () => itAdminApi.getSteelUsers(),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function itaSteelUserRolesQueryOptions(data: { params: {userID: number}}) {
    return queryOptions({
        queryKey: [
            "ita-steel-users-roles",
            {userID: data.params.userID}
        ],
        queryFn: () => itAdminApi.getSteelUserRoles(data),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function itaSteelRolesQueryOptions() {
    return queryOptions({
        queryKey: [
            "ita-steel-roles"
        ],
        queryFn: () => itAdminApi.getSteelRoles(),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function itaSteelLocationsQueryOptions() {
    return queryOptions({
        queryKey: [
            "ita-steel-locations"
        ],
        queryFn: () => itAdminApi.getSteelLocations(),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function useCreateSteelUser() {
    return useMutation({
        mutationKey: ["ita-steel-user"],
        mutationFn: itAdminApi.createSteelUser,
        onSuccess: () => 
        {
            queryClient.invalidateQueries({
                queryKey: itaQueryOptions.itaSteelUserQueryOptions().queryKey
            })
        }
    });
}

function useUpdateSteelUserStatus() {
    return useMutation({
        mutationKey: ["ita-user-status"],
        mutationFn: itAdminApi.updateSteelUserStatus,
    });
}

function useUpdateSteelUserRoles() {
    return useMutation({
        mutationKey: ["ita-user-roles"],
        mutationFn: itAdminApi.updateSteelUser,
    });
}

function taskerWorkRoleQueryOptions() {
    return queryOptions({
        queryKey: [
            "tasker-roles"
        ],
        queryFn: () => itAdminApi.getTaskerRoles(),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function useUpdateTaskerPersonRole() {
    return useMutation({
        mutationKey: ["tasker-user-roles"],
        mutationFn: itAdminApi.updateTaskerRole,
    });
}

function taskerPersonInfoQueryOptions(data: { params: {personCode: string}}) {
    return queryOptions({
        queryKey: [
            "tasker-info",
            {personCode: data.params.personCode}
        ],
        queryFn: () => itAdminApi.getTaskerPersonInfo(data),
        select: (res) => ({
            PersonInfo: res.Item1,
            RoleInfo: res.Item2,
        }),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}


const itaQueryOptions =
{
    itaSteelUserQueryOptions,
    itaSteelRolesQueryOptions,
    itaSteelUserRolesQueryOptions,
    taskerWorkRoleQueryOptions,
    taskerPersonInfoQueryOptions,
    itaSteelLocationsQueryOptions,
}

const itaMutations = 
{
    useCreateSteelUser,
    useUpdateSteelUserStatus,
    useUpdateSteelUserRoles,
    useUpdateTaskerPersonRole
}

export
{
    itaQueryOptions,
    itaMutations
}